import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { PageHeader, DataCard, StatusPill } from "@/components/admin/AdminPrimitives";
import { Skeleton } from "@/components/ui/skeleton";
import { Plus } from "lucide-react";

export const Route = createFileRoute("/_authenticated/admin/downloads")({
  head: () => ({ meta: [{ title: "Downloads — Admin" }, { name: "robots", content: "noindex, nofollow" }] }),
  component: DownloadsAdmin,
});

function DownloadsAdmin() {
  const list = useQuery({
    queryKey: ["admin.downloads"],
    queryFn: async () => (await supabase.from("downloads").select("*").order("sort_order")).data ?? [],
  });
  return (
    <div>
      <PageHeader
        title="Downloads"
        description="Materiais e recursos disponibilizados aos membros."
        actions={
          <button className="inline-flex items-center gap-1.5 rounded-lg bg-[var(--navy)] px-3 py-2 text-sm font-semibold text-white hover:opacity-90">
            <Plus size={14} /> Novo download
          </button>
        }
      />
      <DataCard>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[var(--gray-soft)]/60 text-left text-[11px] uppercase tracking-wide text-[var(--gray-ink)]">
              <tr>
                <th className="px-4 py-3 font-semibold">Título</th>
                <th className="px-4 py-3 font-semibold">Origem</th>
                <th className="px-4 py-3 font-semibold">Status</th>
                <th className="px-4 py-3 font-semibold">Atualizado</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-black/[0.05]">
              {list.isLoading ? (
                Array.from({ length: 4 }).map((_, i) => (
                  <tr key={i}><td colSpan={4} className="p-2"><Skeleton className="h-9 w-full" /></td></tr>
                ))
              ) : (list.data ?? []).length === 0 ? (
                <tr><td colSpan={4} className="py-16 text-center text-sm text-[var(--gray-ink)]">Nenhum download cadastrado.</td></tr>
              ) : (
                (list.data ?? []).map((d: any) => (
                  <tr key={d.id} className="hover:bg-[var(--gray-soft)]/40">
                    <td className="px-4 py-3">
                      <p className="font-semibold text-[var(--navy)]">{d.title}</p>
                      <p className="text-[11px] text-[var(--gray-ink)]">/{d.slug}</p>
                    </td>
                    <td className="px-4 py-3 text-[var(--gray-ink)]">{d.external_url ? "Externo" : d.file_path ? "Arquivo" : "—"}</td>
                    <td className="px-4 py-3"><StatusPill tone={d.active ? "green" : "gray"}>{d.active ? "Ativo" : "Inativo"}</StatusPill></td>
                    <td className="px-4 py-3 text-xs text-[var(--gray-ink)]">{new Date(d.updated_at).toLocaleDateString("pt-BR")}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </DataCard>
    </div>
  );
}
